// extracted by mini-css-extract-plugin
export default {"searchResultBanner":"style-module--searchResultBanner--64137","searchPage":"style-module--searchPage--2bca6"};